import { SET_BUSQUEDA_EXTRUSION, UNSET_BUSQUEDA_EXTRUSION } from '../types'

export const setBusquedaExtrusion = busqueda_realizada => (dispatch, getState) => {
  dispatch({
    type: SET_BUSQUEDA_EXTRUSION,
    payload: busqueda_realizada,
  })
}

export const unsetBusquedaExtrusion = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_BUSQUEDA_EXTRUSION,
  })
}
